import React from 'react';
import styles from './styles.module.less';

type TMobileBanner = {
}

const MobileBanner:React.FC<TMobileBanner> = () => {
  return (
    <div className={styles.pc_banner}>
      <p className={styles.title}>帆软职业资格认证查询</p>
      <p className={styles.subtitle}>可以查询自己考试证书及考试记录，也可用于用人单位核验证书真实性</p>
    </div>
  )
}
export default MobileBanner;
